// import React, { useEffect, useRef, useState } from "react";
// import {
//   doc,
//   onSnapshot,
//   updateDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { db } from "../../firebase";
// import { Chess } from "chess.js";
// import { Chessboard } from "react-chessboard";
// import { LuCrown } from "react-icons/lu";
// import toast from "react-hot-toast";

// // Default avatar
// const USER_AVATAR = "https://img.icons8.com/ios-filled/96/user-male-circle.png";
// const INITIAL_TIME = 10 * 60; // 10 min in seconds

// function getAvatar(player) {
//   if (!player) return USER_AVATAR;
//   if (typeof player === "object" && player.avatar) return player.avatar;
//   return USER_AVATAR;
// }
// function getUsername(player) {
//   if (!player) return "Waiting...";
//   if (typeof player === "object" && player.username) return player.username;
//   return typeof player === "string" ? player : "Waiting...";
// }
// function formatTimer(sec) {
//   sec = Math.max(sec, 0);
//   const m = String(Math.floor(sec / 60)).padStart(2, "0");
//   const s = String(sec % 60).padStart(2, "0");
//   return `${m}:${s}`;
// }

// export default function ChessGameRoom({ gameId, user, setCurrentGameId }) {
//   const [game, setGame] = useState(null);
//   const [chess, setChess] = useState(null);
//   const [fen, setFen] = useState("start");
//   const [moveHistory, setMoveHistory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [myColor, setMyColor] = useState("w");
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   // Show moves state
//   const [showMoves, setShowMoves] = useState(false);
//   const [selected, setSelected] = useState(null);
//   const [moveSquares, setMoveSquares] = useState({});

//   // Chess clock
//   const [wTime, setWTime] = useState(INITIAL_TIME);
//   const [bTime, setBTime] = useState(INITIAL_TIME);
//   const timerRef = useRef();

//   // Responsive
//   useEffect(() => {
//     function handleResize() {
//       setWindowWidth(window.innerWidth);
//     }
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // --- Real-time fetch, including timeLeft
//   useEffect(() => {
//     if (!gameId) return;
//     const unsub = onSnapshot(doc(db, "games", gameId), (snap) => {
//       if (snap.exists()) {
//         const data = snap.data();
//         setGame(data);
//         setMoveHistory(data.moves || []);
//         setWTime(data.wTime !== undefined ? data.wTime : INITIAL_TIME);
//         setBTime(data.bTime !== undefined ? data.bTime : INITIAL_TIME);
//         setLoading(false);
//       } else {
//         setGame(null);
//         setLoading(false);
//       }
//     });
//     return unsub;
//   }, [gameId]);

//   // Setup chess.js
//   useEffect(() => {
//     const chessInstance = new Chess();
//     if (moveHistory && Array.isArray(moveHistory)) {
//       moveHistory.forEach((m) => {
//         try {
//           chessInstance.move(m);
//         } catch (e) {}
//       });
//     }
//     setChess(chessInstance);
//     setFen(chessInstance.fen());
//   }, [moveHistory]);

//   // Set my color
//   useEffect(() => {
//     if (!user || !game?.player1 || !game?.player2) return;
//     if (user.uid === game.player1.userId) setMyColor("w");
//     else if (user.uid === game.player2.userId) setMyColor("b");
//     else setMyColor("w");
//   }, [user, game]);

//   // --- Timer logic (local for active player only)
//   useEffect(() => {
//     if (!game || game.status !== "active") {
//       clearInterval(timerRef.current);
//       return;
//     }
//     // Only run timer if it's your turn
//     if (
//       (myColor === "w" && game.turn === "w") ||
//       (myColor === "b" && game.turn === "b")
//     ) {
//       timerRef.current = setInterval(() => {
//         if (game.turn === "w") setWTime((t) => t - 1);
//         if (game.turn === "b") setBTime((t) => t - 1);
//       }, 1000);
//       return () => clearInterval(timerRef.current);
//     } else {
//       clearInterval(timerRef.current);
//     }
//     return () => clearInterval(timerRef.current);
//     // eslint-disable-next-line
//   }, [game?.turn, game?.status, myColor]);

//   // --- Write time to DB after your move or timer tick
//   useEffect(() => {
//     if (!game || game.status !== "active") return;
//     if (wTime < 0 || bTime < 0) return; // handled below
//     // Write only when it's your turn and timer ticking
//     if (
//       (myColor === "w" && game.turn === "w") ||
//       (myColor === "b" && game.turn === "b")
//     ) {
//       const timerId = setTimeout(async () => {
//         await updateDoc(doc(db, "games", gameId), {
//           wTime,
//           bTime,
//         });
//       }, 500); // Write to DB every 0.5s, avoid spam
//       return () => clearTimeout(timerId);
//     }
//   }, [wTime, bTime, game, myColor, gameId]);

//   // --- Timeout loss ---
//   useEffect(() => {
//     if (!game || game.status !== "active") return;
//     if (wTime < 1 && game.turn === "w") {
//       // Black wins on time
//       handleTimeout("b");
//     } else if (bTime < 1 && game.turn === "b") {
//       // White wins on time
//       handleTimeout("w");
//     }
//     // eslint-disable-next-line
//   }, [wTime, bTime, game]);

//   async function handleTimeout(winner) {
//     await updateDoc(doc(db, "games", gameId), {
//       status: "finished",
//       winner,
//       updatedAt: serverTimestamp(),
//     });
//     toast(
//       winner === myColor
//         ? "Opponent ran out of time! You win! 🎉"
//         : "You lost on time 😢"
//     );
//   }

//   // --- Show Moves / Piece Path Highlight ---
//   function handleSquareClick(square) {
//     if (!chess) return;
//     const moves = chess.moves({ square, verbose: true });
//     if (selected && moveSquares[selected]?.includes(square)) {
//       // Allow normal move if already selected
//       handleMove(selected, square);
//       setMoveSquares({});
//       setSelected(null);
//     } else if (moves.length > 0) {
//       setSelected(square);
//       setMoveSquares({
//         [square]: moves.map((m) => m.to),
//       });
//     } else {
//       setSelected(null);
//       setMoveSquares({});
//     }
//   }
//   function getCustomSquareStyles() {
//     const styles = {};
//     // Show moves highlight
//     if (showMoves && selected && chess) {
//       styles[selected] = {
//         boxShadow: "0 0 0 4px #a3e635cc, 0 2px 12px #bbf7d0",
//         zIndex: 2,
//       };
//       const moves = chess.moves({ square: selected, verbose: true });
//       moves.forEach((m) => {
//         styles[m.to] = {
//           position: "relative",
//           zIndex: 3,
//           background: m.flags.includes("c")
//             ? "radial-gradient(circle at 50% 50%, #f87171bb 40%, transparent 42%)"
//             : "radial-gradient(circle at 50% 50%, #a3e635bb 30%, transparent 32%)",
//           border: m.flags.includes("c")
//             ? "2px solid #f87171"
//             : "2px solid #a3e63544",
//         };
//       });
//     }
//     return styles;
//   }

//   // Move handler
//   async function handleMove(from, to) {
//     if (!chess || !game.status || game.status === "finished") return false;
//     if (
//       (myColor === "w" && game.turn !== "w") ||
//       (myColor === "b" && game.turn !== "b")
//     ) {
//       toast.error("Wait for your turn!");
//       return false;
//     }
//     const moveObj = { from, to, promotion: "q" };
//     const tempChess = new Chess(fen);
//     const move = tempChess.move(moveObj);
//     if (move) {
//       const newMoves = [...moveHistory, moveObj];
//       const winner =
//         tempChess.isGameOver() && tempChess.isCheckmate()
//           ? myColor
//           : tempChess.isDraw()
//           ? "draw"
//           : null;
//       // Calculate time after move
//       let newWTime = wTime;
//       let newBTime = bTime;
//       if (myColor === "w") newWTime = Math.max(wTime, 0);
//       if (myColor === "b") newBTime = Math.max(bTime, 0);

//       await updateDoc(doc(db, "games", gameId), {
//         moves: newMoves,
//         turn: game.turn === "w" ? "b" : "w",
//         winner: winner,
//         updatedAt: serverTimestamp(),
//         status: winner ? "finished" : "active",
//         wTime: newWTime,
//         bTime: newBTime,
//       });
//       setMoveHistory(newMoves);
//       setFen(tempChess.fen());
//       setSelected(null);
//       setMoveSquares({});
//       if (winner === myColor) toast.success("Checkmate! You win!");
//       if (winner === "draw") toast("Game drawn.");
//       return true;
//     } else {
//       toast.error("Invalid move!");
//       return false;
//     }
//   }

//   // Game result display
//   let gameResult = null;
//   if (game?.status === "finished") {
//     if (game.winner === "draw") {
//       gameResult = (
//         <div className="mt-2 text-2xl font-bold text-yellow-400">Draw!</div>
//       );
//     } else if (
//       (game.winner === "w" && myColor === "w") ||
//       (game.winner === "b" && myColor === "b")
//     ) {
//       gameResult = (
//         <div className="mt-2 text-2xl font-bold text-lime-400">You Win! 🎉</div>
//       );
//     } else {
//       gameResult = (
//         <div className="mt-2 text-2xl font-bold text-pink-400">You Lose 😢</div>
//       );
//     }
//   }

//   // Responsive board
//   const boardWidth = windowWidth < 600 ? 300 : 370;
//   const playerWhite = game?.player1;
//   const playerBlack = game?.player2;
//   const you = myColor === "w" ? playerWhite : playerBlack;
//   const opponent = myColor === "w" ? playerBlack : playerWhite;

//   // --- Main UI ---
//   return loading ? (
//     <div className="text-center mt-16">Loading game…</div>
//   ) : !game ? (
//     <div className="text-center mt-16">Game not found.</div>
//   ) : (
//     <div className="flex flex-col items-center justify-center min-h-screen py-10 px-2 bg-gradient-to-br from-slate-950 to-green-950">
//       <div className="bg-slate-900 border-2 border-lime-400 rounded-2xl shadow-2xl max-w-lg w-full flex flex-col items-center p-6">
//         {/* Title + Players */}
//         <div className="text-lime-400 font-extrabold text-3xl mb-1 text-center flex items-center gap-2">
//           <LuCrown size={32} className="inline text-lime-300" /> Chess
//         </div>
//         <div className="flex gap-3 mb-2 items-center justify-center">
//           <span
//             className={
//               "px-3 py-1 rounded-xl text-xs font-bold " +
//               (game.turn === myColor
//                 ? "bg-lime-400 text-slate-900"
//                 : "bg-slate-700 text-lime-300")
//             }
//           >
//             {game.turn === myColor ? "Your Turn" : "Opponent's Turn"}
//           </span>
//           {/* Timers */}
//           <span className="text-sm ml-2 flex gap-2">
//             <span
//               className={
//                 myColor === "w"
//                   ? "text-lime-400 font-bold"
//                   : "text-slate-300 font-bold"
//               }
//             >
//               {formatTimer(myColor === "w" ? wTime : bTime)}
//             </span>
//             <span className="mx-1 text-slate-500">/</span>
//             <span
//               className={
//                 myColor === "b"
//                   ? "text-lime-400 font-bold"
//                   : "text-slate-300 font-bold"
//               }
//             >
//               {formatTimer(myColor === "w" ? bTime : wTime)}
//             </span>
//           </span>
//         </div>
//         <div className="flex justify-center items-center gap-8 mb-2">
//           {/* You */}
//           <div className="flex flex-col items-center">
//             <img
//               src={getAvatar(you)}
//               alt="you"
//               className="w-12 h-12 rounded-full border-2 border-lime-300"
//             />
//             <span className="mt-1 font-semibold text-lime-300 text-sm">
//               {getUsername(you)}
//             </span>
//             <span className="text-xs text-slate-400">
//               {myColor === "w" ? "White" : "Black"}
//             </span>
//           </div>
//           <div className="text-2xl font-bold text-lime-400">vs</div>
//           {/* Opponent */}
//           <div className="flex flex-col items-center">
//             <img
//               src={getAvatar(opponent)}
//               alt="opponent"
//               className="w-12 h-12 rounded-full border-2 border-slate-400"
//             />
//             <span className="mt-1 font-semibold text-lime-300 text-sm">
//               {getUsername(opponent)}
//             </span>
//             <span className="text-xs text-slate-400">
//               {myColor === "w" ? "Black" : "White"}
//             </span>
//           </div>
//         </div>

//         {/* Board */}
//         <div className="my-2 flex justify-center w-full">
//           <Chessboard
//             position={fen}
//             arePiecesDraggable={
//               game.status === "active" && game.turn === myColor
//             }
//             boardOrientation={myColor === "w" ? "white" : "black"}
//             onPieceDrop={async (from, to) => {
//               if (showMoves) return false; // Only allow drag if not showing moves
//               return await handleMove(from, to);
//             }}
//             onSquareClick={showMoves ? handleSquareClick : undefined}
//             customSquareStyles={getCustomSquareStyles()}
//             boardWidth={boardWidth}
//             customBoardStyle={{
//               borderRadius: 16,
//               boxShadow: "0 6px 32px 0 #0006",
//               border: "3px solid #bef264",
//             }}
//             animationDuration={150}
//           />
//         </div>

//         {/* Show Moves Button */}
//         <div className="flex flex-row gap-2 mb-2">
//           <button
//             className={
//               "px-4 py-2 rounded-lg font-bold transition " +
//               (showMoves
//                 ? "bg-lime-400 text-slate-900"
//                 : "bg-slate-700 text-lime-300 hover:bg-slate-600")
//             }
//             onClick={() => {
//               setShowMoves((v) => !v);
//               setSelected(null);
//               setMoveSquares({});
//             }}
//           >
//             {showMoves ? "Disable Show Moves" : "Show Moves"}
//           </button>
//         </div>

//         {/* Result */}
//         {gameResult}

//         <button
//           className="mt-7 px-8 py-2 bg-lime-400 rounded-xl font-bold shadow hover:bg-lime-300"
//           onClick={() => setCurrentGameId(null)}
//         >
//           Back to Lobby
//         </button>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import {
  doc,
  onSnapshot,
  updateDoc,
  serverTimestamp,
  runTransaction,
  getDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { Chess } from "chess.js";
import { Chessboard } from "react-chessboard";
import { LuCrown } from "react-icons/lu";
import toast from "react-hot-toast";

const USER_AVATAR = "https://img.icons8.com/ios-filled/96/user-male-circle.png";
const INITIAL_TIME = 10 * 60; // 10 min in seconds

function getAvatar(player) {
  if (!player) return USER_AVATAR;
  if (typeof player === "object" && player.avatar) return player.avatar;
  return USER_AVATAR;
}
function getUsername(player) {
  if (!player) return "Waiting...";
  if (typeof player === "object" && player.username) return player.username;
  return typeof player === "string" ? player : "Waiting...";
}
function formatTimer(sec) {
  sec = Math.max(sec, 0);
  const m = String(Math.floor(sec / 60)).padStart(2, "0");
  const s = String(sec % 60).padStart(2, "0");
  return `${m}:${s}`;
}

// --- Modal for exit confirmation ---
function ForfeitModal({ open, onClose, onConfirm }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="bg-slate-900 border-2 border-lime-400 p-8 rounded-2xl shadow-xl max-w-xs w-full flex flex-col items-center">
        <div className="mb-3 text-lime-300 font-bold text-lg">
          Are you sure you want to leave?
        </div>
        <div className="text-slate-200 text-center mb-5">
          If you exit now,{" "}
          <span className="text-pink-400 font-bold">
            you will forfeit and lose your bet
          </span>
          . Your opponent will win.
        </div>
        <div className="flex gap-3 w-full">
          <button
            className="flex-1 bg-slate-700 text-white rounded-xl py-2 font-semibold hover:bg-slate-800"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-pink-400 text-[#161f2b] font-bold rounded-xl py-2 hover:bg-pink-300"
            onClick={onConfirm}
          >
            Forfeit & Leave
          </button>
        </div>
      </div>
    </div>
  );
}

// --- PAYOUT LOGIC ---
async function handlePayout({ winnerUid, loserUid, betAmount, draw = false }) {
  // Firestore user structure: balance field (number)
  const winnerRef = doc(db, "users", winnerUid);
  const loserRef = doc(db, "users", loserUid);

  if (draw) {
    // Both get their bet back
    await runTransaction(db, async (tx) => {
      const wSnap = await tx.get(winnerRef);
      const lSnap = await tx.get(loserRef);
      tx.update(winnerRef, {
        balance: (wSnap.data().balance || 0) + betAmount,
      });
      tx.update(loserRef, { balance: (lSnap.data().balance || 0) + betAmount });
    });
  } else {
    // Winner gets their bet + 80% of loser's, loser gets nothing
    const winnerPrize = betAmount + betAmount * 0.8;
    await runTransaction(db, async (tx) => {
      const wSnap = await tx.get(winnerRef);
      tx.update(winnerRef, {
        balance: (wSnap.data().balance || 0) + winnerPrize,
      });
      // Loser gets nothing (already deducted on join)
    });
  }
}

export default function ChessGameRoom({ gameId, user, setCurrentGameId }) {
  const [game, setGame] = useState(null);
  const [chess, setChess] = useState(null);
  const [fen, setFen] = useState("start");
  const [moveHistory, setMoveHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [myColor, setMyColor] = useState("w");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Clock/timer
  const [wTime, setWTime] = useState(INITIAL_TIME);
  const [bTime, setBTime] = useState(INITIAL_TIME);
  const timerRef = useRef();

  // Show moves state
  const [showMoves, setShowMoves] = useState(false);
  const [selected, setSelected] = useState(null);
  const [moveSquares, setMoveSquares] = useState({});
  // Modal
  const [forfeitModal, setForfeitModal] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // --- Real-time fetch (Firestore listener) ---
  useEffect(() => {
    if (!gameId) return;
    const unsub = onSnapshot(doc(db, "games", gameId), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setGame(data);
        setMoveHistory(data.moves || []);
        setWTime(data.wTime !== undefined ? data.wTime : INITIAL_TIME);
        setBTime(data.bTime !== undefined ? data.bTime : INITIAL_TIME);
        setLoading(false);
      } else {
        setGame(null);
        setLoading(false);
      }
    });
    return unsub;
  }, [gameId]);

  // --- Setup chess.js ---
  useEffect(() => {
    const chessInstance = new Chess();
    if (moveHistory && Array.isArray(moveHistory)) {
      moveHistory.forEach((m) => {
        try {
          chessInstance.move(m);
        } catch (e) {}
      });
    }
    setChess(chessInstance);
    setFen(chessInstance.fen());
  }, [moveHistory]);

  // --- Set my color ---
  useEffect(() => {
    if (!user || !game?.player1 || !game?.player2) return;
    if (user.uid === game.player1.userId) setMyColor("w");
    else if (user.uid === game.player2.userId) setMyColor("b");
    else setMyColor("w");
  }, [user, game]);

  // --- Timer logic (real time, server-based) ---
  useEffect(() => {
    if (!game || game.status !== "active") {
      clearInterval(timerRef.current);
      return;
    }
    // Only run timer if it's your turn
    if (
      (myColor === "w" && game.turn === "w") ||
      (myColor === "b" && game.turn === "b")
    ) {
      timerRef.current = setInterval(() => {
        if (game.turn === "w") setWTime((t) => Math.max(0, t - 1));
        if (game.turn === "b") setBTime((t) => Math.max(0, t - 1));
      }, 1000);
      return () => clearInterval(timerRef.current);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line
  }, [game?.turn, game?.status, myColor]);

  // --- Write time to DB after your move or timer tick
  useEffect(() => {
    if (!game || game.status !== "active") return;
    if (wTime < 0 || bTime < 0) return; // handled below
    // Write only when it's your turn and timer ticking
    if (
      (myColor === "w" && game.turn === "w") ||
      (myColor === "b" && game.turn === "b")
    ) {
      const timerId = setTimeout(async () => {
        await updateDoc(doc(db, "games", gameId), {
          wTime,
          bTime,
        });
      }, 500); // Write to DB every 0.5s, avoid spam
      return () => clearTimeout(timerId);
    }
  }, [wTime, bTime, game, myColor, gameId]);

  // --- Timeout loss + payout ---
  useEffect(() => {
    if (!game || game.status !== "active") return;
    if (wTime < 1 && game.turn === "w") {
      handleFinishGame("b", "timeout");
    } else if (bTime < 1 && game.turn === "b") {
      handleFinishGame("w", "timeout");
    }
    // eslint-disable-next-line
  }, [wTime, bTime, game]);

  // --- Handle move ---
  async function handleMove(from, to) {
    if (!chess || !game.status || game.status === "finished") return false;
    if (
      (myColor === "w" && game.turn !== "w") ||
      (myColor === "b" && game.turn !== "b")
    ) {
      toast.error("Wait for your turn!");
      return false;
    }
    const moveObj = { from, to, promotion: "q" };
    const tempChess = new Chess(fen);
    const move = tempChess.move(moveObj);
    if (move) {
      const newMoves = [...moveHistory, moveObj];
      // -- Determine outcome
      let winner = null;
      let draw = false;
      if (tempChess.isGameOver()) {
        if (tempChess.isCheckmate()) winner = myColor;
        else if (tempChess.isDraw()) draw = true;
      }
      // Save timers
      let newWTime = wTime;
      let newBTime = bTime;
      if (myColor === "w") newWTime = Math.max(wTime, 0);
      if (myColor === "b") newBTime = Math.max(bTime, 0);

      await updateDoc(doc(db, "games", gameId), {
        moves: newMoves,
        turn: game.turn === "w" ? "b" : "w",
        winner: draw ? "draw" : winner,
        updatedAt: serverTimestamp(),
        status: draw || winner ? "finished" : "active",
        wTime: newWTime,
        bTime: newBTime,
      });

      // Payout on finish
      if (draw || winner) {
        await payoutIfNeeded(draw ? "draw" : winner);
      }

      setMoveHistory(newMoves);
      setFen(tempChess.fen());
      setSelected(null);
      setMoveSquares({});
      if (winner === myColor) toast.success("Checkmate! You win!");
      if (draw) toast("Game drawn.");
      return true;
    } else {
      toast.error("Invalid move!");
      return false;
    }
  }

  // --- End game and payout ---
  async function handleFinishGame(winnerColor, reason = "") {
    if (!game || game.status !== "active") return;
    const winnerUid =
      winnerColor === "w" ? game.player1.userId : game.player2.userId;
    const loserUid =
      winnerColor === "w" ? game.player2.userId : game.player1.userId;
    await updateDoc(doc(db, "games", gameId), {
      status: "finished",
      winner: winnerColor,
      updatedAt: serverTimestamp(),
      reason,
    });
    await payoutIfNeeded(winnerColor);
    toast(
      winnerColor === myColor
        ? "Opponent ran out of time! You win! 🎉"
        : "You lost on time 😢"
    );
  }

  // --- Forfeit and payout ---
  async function handleForfeit() {
    if (!game || game.status !== "active") {
      setCurrentGameId(null);
      return;
    }
    // Opponent wins
    const winnerColor = myColor === "w" ? "b" : "w";
    await handleFinishGame(winnerColor, "forfeit");
    setCurrentGameId(null);
  }

  // --- PAYOUT helper: prevent double payout ---
  async function payoutIfNeeded(winnerColor) {
    // Use a "paidOut" flag in game doc
    const g = await getDoc(doc(db, "games", gameId));
    if (!g.exists() || g.data().paidOut) return;

    const betAmount = g.data().betAmount || 0.5;
    const player1 = g.data().player1;
    const player2 = g.data().player2;

    if (winnerColor === "draw") {
      // Draw: refund both
      await handlePayout({
        winnerUid: player1.userId,
        loserUid: player2.userId,
        betAmount,
        draw: true,
      });
      await updateDoc(doc(db, "games", gameId), { paidOut: true });
    } else {
      // Someone won
      const winnerUid = winnerColor === "w" ? player1.userId : player2.userId;
      const loserUid = winnerColor === "w" ? player2.userId : player1.userId;
      await handlePayout({ winnerUid, loserUid, betAmount });
      await updateDoc(doc(db, "games", gameId), { paidOut: true });
    }
  }

  // --- Show moves / path ---
  function handleSquareClick(square) {
    if (!chess) return;
    const moves = chess.moves({ square, verbose: true });
    if (selected && moveSquares[selected]?.includes(square)) {
      handleMove(selected, square);
      setMoveSquares({});
      setSelected(null);
    } else if (moves.length > 0) {
      setSelected(square);
      setMoveSquares({
        [square]: moves.map((m) => m.to),
      });
    } else {
      setSelected(null);
      setMoveSquares({});
    }
  }
  function getCustomSquareStyles() {
    const styles = {};
    if (showMoves && selected && chess) {
      styles[selected] = {
        boxShadow: "0 0 0 4px #a3e635cc, 0 2px 12px #bbf7d0",
        zIndex: 2,
      };
      const moves = chess.moves({ square: selected, verbose: true });
      moves.forEach((m) => {
        styles[m.to] = {
          position: "relative",
          zIndex: 3,
          background: m.flags.includes("c")
            ? "radial-gradient(circle at 50% 50%, #f87171bb 40%, transparent 42%)"
            : "radial-gradient(circle at 50% 50%, #a3e635bb 30%, transparent 32%)",
          border: m.flags.includes("c")
            ? "2px solid #f87171"
            : "2px solid #a3e63544",
        };
      });
    }
    return styles;
  }

  // --- Result UI ---
  let gameResult = null;
  if (game?.status === "finished") {
    if (game.winner === "draw") {
      gameResult = (
        <div className="mt-2 text-2xl font-bold text-yellow-400">Draw!</div>
      );
    } else if (
      (game.winner === "w" && myColor === "w") ||
      (game.winner === "b" && myColor === "b")
    ) {
      gameResult = (
        <div className="mt-2 text-2xl font-bold text-lime-400">You Win! 🎉</div>
      );
    } else {
      gameResult = (
        <div className="mt-2 text-2xl font-bold text-pink-400">You Lose 😢</div>
      );
    }
  }

  // --- Responsive ---
  const boardWidth = windowWidth < 600 ? 300 : 370;
  const playerWhite = game?.player1;
  const playerBlack = game?.player2;
  const you = myColor === "w" ? playerWhite : playerBlack;
  const opponent = myColor === "w" ? playerBlack : playerWhite;

  return loading ? (
    <div className="text-center mt-16">Loading game…</div>
  ) : !game ? (
    <div className="text-center mt-16">Game not found.</div>
  ) : (
    <div className="flex flex-col items-center justify-center min-h-screen py-10 px-2 bg-gradient-to-br from-slate-950 to-green-950">
      {/* Forfeit Modal */}
      <ForfeitModal
        open={forfeitModal}
        onClose={() => setForfeitModal(false)}
        onConfirm={handleForfeit}
      />
      <div className="bg-slate-900 border-2 border-lime-400 rounded-2xl shadow-2xl max-w-lg w-full flex flex-col items-center p-6">
        {/* Title + Players */}
        <div className="text-lime-400 font-extrabold text-3xl mb-1 text-center flex items-center gap-2">
          <LuCrown size={32} className="inline text-lime-300" /> Chess
        </div>
        <div className="flex gap-3 mb-2 items-center justify-center">
          <span
            className={
              "px-3 py-1 rounded-xl text-xs font-bold " +
              (game.turn === myColor
                ? "bg-lime-400 text-slate-900"
                : "bg-slate-700 text-lime-300")
            }
          >
            {game.turn === myColor ? "Your Turn" : "Opponent's Turn"}
          </span>
          {/* Timers */}
          <span className="text-sm ml-2 flex gap-2">
            <span
              className={
                myColor === "w"
                  ? "text-lime-400 font-bold"
                  : "text-slate-300 font-bold"
              }
            >
              {formatTimer(myColor === "w" ? wTime : bTime)}
            </span>
            <span className="mx-1 text-slate-500">/</span>
            <span
              className={
                myColor === "b"
                  ? "text-lime-400 font-bold"
                  : "text-slate-300 font-bold"
              }
            >
              {formatTimer(myColor === "w" ? bTime : wTime)}
            </span>
          </span>
        </div>
        <div className="flex justify-center items-center gap-8 mb-2">
          {/* You */}
          <div className="flex flex-col items-center">
            <img
              src={getAvatar(you)}
              alt="you"
              className="w-12 h-12 rounded-full border-2 border-lime-300"
            />
            <span className="mt-1 font-semibold text-lime-300 text-sm">
              {getUsername(you)}
            </span>
            <span className="text-xs text-slate-400">
              {myColor === "w" ? "White" : "Black"}
            </span>
          </div>
          <div className="text-2xl font-bold text-lime-400">vs</div>
          {/* Opponent */}
          <div className="flex flex-col items-center">
            <img
              src={getAvatar(opponent)}
              alt="opponent"
              className="w-12 h-12 rounded-full border-2 border-slate-400"
            />
            <span className="mt-1 font-semibold text-lime-300 text-sm">
              {getUsername(opponent)}
            </span>
            <span className="text-xs text-slate-400">
              {myColor === "w" ? "Black" : "White"}
            </span>
          </div>
        </div>

        {/* Board */}
        <div className="my-2 flex justify-center w-full">
          <Chessboard
            position={fen}
            arePiecesDraggable={
              game.status === "active" && game.turn === myColor
            }
            boardOrientation={myColor === "w" ? "white" : "black"}
            onPieceDrop={async (from, to) => {
              if (showMoves) return false; // Only allow drag if not showing moves
              return await handleMove(from, to);
            }}
            onSquareClick={showMoves ? handleSquareClick : undefined}
            customSquareStyles={getCustomSquareStyles()}
            boardWidth={boardWidth}
            customBoardStyle={{
              borderRadius: 16,
              boxShadow: "0 6px 32px 0 #0006",
              border: "3px solid #bef264",
            }}
            animationDuration={150}
          />
        </div>

        {/* Show Moves Button */}
        <div className="flex flex-row gap-2 mb-2">
          <button
            className={
              "px-4 py-2 rounded-lg font-bold transition " +
              (showMoves
                ? "bg-lime-400 text-slate-900"
                : "bg-slate-700 text-lime-300 hover:bg-slate-600")
            }
            onClick={() => {
              setShowMoves((v) => !v);
              setSelected(null);
              setMoveSquares({});
            }}
          >
            {showMoves ? "Disable Show Moves" : "Show Moves"}
          </button>
        </div>

        {/* Result */}
        {gameResult}

        <button
          className="mt-7 px-8 py-2 bg-lime-400 rounded-xl font-bold shadow hover:bg-lime-300"
          onClick={() => {
            if (game.status === "active") {
              setForfeitModal(true);
            } else {
              setCurrentGameId(null);
            }
          }}
        >
          Back to Lobby
        </button>
      </div>
    </div>
  );
}
